export default {
    'single-quiz': require( './quiz-controller' ),
}
